import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

import calendarIcon from '#/assets/icons/calendar.svg';
import 'moment/locale/pt-br';
import './styles.css';

import { useTranslation } from "react-i18next";


moment.locale('pt-BR');

function Calendar({ date: { date, setDate } }) {
  const [focused, setFocused] = useState(null);
  const [tempDate, setTempDate] = useState({
    startDate: null,
    endDate: moment(),
  });
  const { t } = useTranslation();

  useEffect(() => {
    setTempDate(date);
  }, [date]);

  const onDatesChange = ({ startDate, endDate }) => {
       setTempDate({
        startDate,
        endDate,
      });
  };

  const handleClose = () => {
    if (!!tempDate.startDate && !!tempDate.endDate) {
      setDate({
        startDate: tempDate.startDate,
        endDate: tempDate.endDate,
      });
    }
  };

  const isOutsideRange = (day) => {
    const daysBetween = day.diff(tempDate.startDate, 'days') + 1;
    return daysBetween > 62;
  }

  return (
    <div className="date-wrapper">
      <label className="date">
        <img
          src={calendarIcon}
          alt={t('CALENDAR_ICON')}
          className="calendar-icon"
        />
        <p className="paragraph">{t('DATE')}</p>
      </label>
      {date.startDate && date.endDate ? (
        <DateRangePicker
          numberOfMonths={2}
          onClose={handleClose}
          onDatesChange={onDatesChange}
          focusedInput={focused}
          startDate={tempDate.startDate}
          endDate={tempDate.endDate}
          startDateId="start_date_id"
          endDateId="end_date_id"
          small
          keepOpenOnDateSelect
          hideKeyboardShortcutsPanel
          startDatePlaceholderText={t('START')}
          endDatePlaceholderText={t('FINISH')}
          displayFormat={() => 'DD/MM/YYYY'}
          weekDayFormat="ddd"
          onFocusChange={focusedInput => setFocused(focusedInput)}
          isOutsideRange={isOutsideRange}
          minimumNights={0}
        />
      ) : null}
    </div>
  );
}



Calendar.propTypes = {
  date: PropTypes.shape({
    date: PropTypes.object,
    setDate: PropTypes.func,
  }),
};

export default Calendar;
